import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpEvent,
  HttpHeaders,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import {
  catchError,
  retry,
} from 'rxjs/operators';

import Swal from 'sweetalert2';
import { Router } from '@angular/router';

@Injectable()
export class ErrorHandlerInterceptor implements HttpInterceptor {
  constructor(private router: Router) {}
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      retry(2),
      catchError((error: HttpErrorResponse) => this.errorHandler(error))
    );
  }

  logOut(){
    localStorage.removeItem('user')
    localStorage.removeItem ('token')
    this.router.navigate(['/auth']);
    localStorage.removeItem ('customer')
    
  }

  errorHandler(error: HttpErrorResponse) {
    console.log(error);
    let content = '';
    if (error.status >= 400 && error.status < 500) {
      if (error.status === 401 || error.status === 403)
      this.logOut()
      else{
        content = error.error.error.message;
        
        Swal.fire('Algo paso vuelve a intentarlo', content, "error")
      }
    }else{
      content = error.error.message;
      Swal.fire('Algo paso vuelve a intentarlo', content, "error")
    }
    if (error.status == 404 && error.error.path.includes('companyYield')) {
      return throwError('Error personalizado');
    }

    /* const modalRef = this.modalSvc.show(OperationFinishedModalComponent, {
      initialState: {
        title: content || 'Algo paso vuelve a intentarlo',
        content: '',
        successful: false,
      },
    }); */
    return throwError({ error });
  }
}
